import axios from 'axios'

export default {
  async getAll (params) {
    return await axios.get('/api/spa/v1/settings', { params })
  },
  async updateOrCreate (params) {
    await axios.post('/api/spa/v1/settings', params)
  },
  async getSetting (key) {
    return await axios.get('/api/spa/v1/settings/' + key)
  },
  async sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

}
